const SplitTestConstants = {
  ZRM_TENANT_PLACEMENT_W_PROPERTY_MANAGEMENT: 'tenant-placement-w-property-management',
  ZRM_VALUE_OF_PREMIUM: 'zrm-value-of-premium',
  ZRM_PROPERTY_DESCRIPTION_REORDER: 'zrm-property-description-reorder-2',
} as const;

export default SplitTestConstants;
